import { EventEmitter, Injectable, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IFiltersObject } from '../../../models/common';
import {
    DateFilter,
    DecimalFilter,
    EnumFilter,
    IntegerFilter,
    StringFilter
} from '@lsq-frontend/remote-services/enterprise/common';
import { ITableColumn } from '../../models/table-column';

@Injectable()
export abstract class BaseFilterComponent implements OnInit {
    @Input() public abstract filter:
        | DecimalFilter
        | StringFilter
        | DateFilter
        | EnumFilter<number>
        | IntegerFilter;
    @Input() public column: ITableColumn;
    @Output() public updated = new EventEmitter<IFiltersObject>();

    public formGroup: FormGroup;

    public ngOnInit(): void {
        this.formGroup = this.createFormGroup();
        this.setFilterValues();
    }

    // Updates the filter externally.
    public abstract emitFilterUpdate(): void;

    // Updates the filter form internally.
    public abstract setFilterValues(): void;

    // Create the formgroup for the filter.
    public abstract createFormGroup(): FormGroup;
}
